import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { useEffect, useState } from "react";

export interface ReactSelectType {
  value: any;
  label?: string;
}

const ReactSelectField = ({
  input,
  label,
  options,
  meta: { touched, error },
  helpText,
  name,
  className,
  disabled,
  textBlur,
  isClearable,
  defaultValue
}: any) => {
  const [selectValue, setSelectValue] = useState<
    ReactSelectType[] | ReactSelectType | null
  >();

  useEffect(() => {
    if (input?.value && !input.value?.label) {
      const defaultOption = (options as ReactSelectType[])?.filter((each) => {
        if (typeof each?.value === "number" && +each?.value === +input.value) {
          return each;
        } else if (
          typeof each?.value === "boolean" &&
          each?.value &&
          input.value === "true" &&
          !each?.value &&
          input.value === "false"
        ) {
          return each;
        } else if (each?.value === input.value) {
          return each;
        } else {
          return false;
        }
      });
      setSelectValue(defaultOption);
    } else if (input?.value && input.value.label) {
      setSelectValue(input.value);
    } else if (input?.value === "") {
      setSelectValue(null);
    } else {
      setSelectValue(null);
    }
  }, [input.value, options]); 
  return (
    <FormGroup className="select-option">
      {label && <Label for="select">{label}</Label>}
      <Select
        options={options}
        defaultValue = {defaultValue}
        {...input}
        id="select"
        name={name || "select"}
        className={className}
        value={selectValue}
        onChange={(value: any) => {
          input.onChange(value);
          setSelectValue(value);
        }}
        onBlur={(event: any) => {
          if (textBlur) textBlur(event, input.value);
          input.onBlur();
        }}
        isDisabled={disabled}
        placeholder={helpText}
        isClearable={isClearable}
        classNamePrefix="selectField"
      />
      {touched && error && input.value === "" ? (
        <h6 className="danger">{error}</h6>
      ) : (
        ""
      )}
    </FormGroup>
  );
};
export default ReactSelectField;
